const pathUrl ='https://www.jlszhgh.com/';
// 公用方法
String.prototype.toImg = function () {
    return this.includes('http') ? this : `${pathUrl}download?url=${this}`
}
// 公用方法
Array.prototype.toImg = function () {
    return this.map(url => {
        return  url.includes('http') ? url : `${pathUrl}download?url=${url}`;
    })
}

